<div class="flex flex-col gap-6 py-8" *transloco="let t">
  <h4>{{ t("common.creatives") }}</h4>

  @if (!isAwareness()) {
    <app-dsp-creative-type-selector
      [creativeType]="creative().creativeType().value()!"
      (creativeTypeChange)="selectCreativeType($event)"
    />
  }

  @if (withVideoSection()) {
    <app-dsp-creative
      [assetId]="creative().videoAssetId().value() ?? ''"
      [addAssetLabel]="t('dsp-creatives.add_a_video')"
      [mediaType]="MediaType.videoAsset"
      [funnel]="funnel() ?? undefined"
      [allowDelete]="false"
      [allowedVideoDurations]="videoDealAllowedDurations()"
      (selectedAssetId)="selectVideo($event)"
      (assetToUpload)="uploadVideo($event)"
      (videoDurationSeconds)="videoDurationSeconds.emit($event)"
    />
  } @else if (isDisplayCreative()) {
    <span class="type-label text-muted-foreground">
      {{ t("dsp-create-strategy-page.display_creative_type_info") }}
    </span>
  }
</div>
